import React, { useEffect, useState } from 'react';
import { PrimaryButton } from './PrimaryButton';
import { CHECKOUT_URL } from '../../utils/checkout';
export function StickyCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setVisible(window.scrollY > 640);
        ticking = false;
      });
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-brown/20 bg-bg-secondary/95 backdrop-blur-sm transition-transform duration-300 lg:hidden ${visible ? 'translate-y-0' : 'translate-y-full'}`} aria-hidden={!visible} data-id="element-262" data-mp="2nvnf5h3e3ihq">
      <div className="flex items-center justify-between gap-3 px-4 py-3" data-id="element-263" data-mp="2sw1n6z4zqsfr">
        <div data-id="element-264" data-mp="2stylhhuh7av7">
          <p className="font-heading text-sm font-bold text-ink" data-id="element-265" data-mp="o0l2gkc3ccjc">19€</p>
          <p className="text-[11px] text-muted" data-id="element-266" data-mp="o2nzvpfkp7y3">Acceso inmediato</p>
        </div>
        <PrimaryButton size="md" showArrow={false} href={CHECKOUT_URL} data-id="element-267" data-mp="s2oo21sh4xic">
          Quiero el Kit
        </PrimaryButton>
      </div>
    </div>;
}